import { Address, generateAddressFG } from './address.model';
import { Phone } from './phone.model';
import { generateRepresentativeFG, Representative } from './representative.model';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';

export interface PhysicalPerson {
    dni?: string;
    pasaporte?: string;
    cuit?: string;
    sexo?: string;
    nombre: string;
    apellido: string;
    email?: string;
    celular: Phone;
    fechaNacimiento?: string;
    direccion?: Address;
    representante?: Representative;
}

export function generatePhysicalPersonFG(from: 'TENANT' | 'OWNER', withRepresentative = true) {
    const group = new UntypedFormGroup({
        tipoDocumento: new UntypedFormControl('DNI', [Validators.required]), // NUEVO
        dni: new UntypedFormControl('', []),  // MODIFICADO: sin validadores por defecto
        pasaporte: new UntypedFormControl('', []), // NUEVO
        sexo: new UntypedFormControl('M', [Validators.required]),
        nombre: new UntypedFormControl('', [Validators.required]),
        apellido: new UntypedFormControl('', [Validators.required]),
        celular: new UntypedFormControl('', [Validators.required]),
        fechaNacimiento: new UntypedFormControl('', [Validators.required]),
        representante: withRepresentative ? generateRepresentativeFG() : new UntypedFormControl([], [])
    });

    // NUEVO: Configurar validadores iniciales para DNI
    group.controls.dni.setValidators([Validators.required, Validators.minLength(8), Validators.maxLength(8)]);
    group.controls.dni.updateValueAndValidity();

    if (from === 'OWNER') {
        group.addControl('direccion', generateAddressFG());
    }
    return group;
}